// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a82e9fca","54":"3dd18ac8","94":"06068557","228":"6b2813b2","264":"af754be8","275":"c2b49290","421":"6c715de2","468":"5c04f182","471":"5bb41851","480":"aa42782f","488":"b9d07991","591":"4e41547f","633":"e955e687","682":"01b2b29d","721":"13a01336","962":"f67d578f"}[chunkId] + ".chunk.js";
};